import { PropsWithChildren } from 'react';

import styles from './settings.module.css';
import { Language } from '../language';
import { Popover } from '../popover/popover';

type SettingsProps = PropsWithChildren<{}>;
export const Settings = ({ children }: SettingsProps) => (
  <Popover
    trigger={
      <button className={styles.trigger}>
        <Language />
      </button>
    }
    offset={10}
  >
    <div className={styles.settings}>{children}</div>
  </Popover>
);
